/**
 * reminderSampleVars — the SAMPLE patient the message boxes on Appointment Reminders → Settings fill in.
 *
 * MessageTemplateBox measures a message (characters, credits) and previews it with these values instead of
 * the literal `{{tokens}}`, because that is what a patient is actually texted. They are deliberately plain
 * ASCII (a single accented letter would flip the estimate to UCS-2 and double the cost shown) and roughly
 * the length of a real value. The counter says it is an estimate: real names and dates vary per patient.
 *
 * Values come from the design package (docs/plans/2026-10-17-inline-reminder-messages-plan.md §2.7); the four
 * the design left open (family_appts, minor_names, recall_due_date, online_apttype) are reasonable stand-ins.
 * Every key must be a KNOWN_TEMPLATE_VARIABLE and every chip of every default message must have a value here
 * (cypress/node-tests/apt-reminder-inline-messages.test.js).
 *
 * ⛔ KEEP THIS FILE IMPORT-FREE (the node-tests execute it verbatim).
 */
export const REMINDER_SAMPLE_VARS = Object.freeze({
  site_name: 'Mint Dental',
  patient_first_name: 'Christopher',
  guarantor_first_name: 'Maria',
  // apt_date / family_appts in the exe's real format (worker.js: 'MM-DD-YYYY hh:mm A', family lines "<FName> at <date>"),
  // so the preview shows what a patient really reads. 10-21-2026 is a Wednesday, matching apt_dayofweek.
  apt_date: '10-21-2026 10:00 AM',
  apt_dayofweek: 'Wednesday',
  apt_provider: 'Dr. Patel',
  site_officephone: '(201) 555-0142',
  family_appts: 'Christopher at 10-21-2026 10:00 AM\nMaria at 10-21-2026 11:00 AM',
  recall_due_date: 'Nov 3',
  minor_names: 'Christopher',
  online_apttype: 'Cleaning',
  // Email-only (the confirm buttons are HTML the exe builds); blank so an SMS never measures it.
  confirm_button: '',
});

// The online-scheduling link ({{online_scheduling_link}}, recall messages only; docs/plans/2026-10-19-online-scheduling-
// link-token-plan.md section 3.4). It is deliberately NOT a key of REMINDER_SAMPLE_VARS (that map is "every key is a
// KNOWN_TEMPLATE_VARIABLE", and the token is not one); MessageTemplateBox adds it to the samples only inside a box that
// may hold it. SAMPLE is what the counter measures: the real short link is https://prod.teamio.app/b/<7 characters>,
// plain ASCII so the estimate stays GSM-7. PREVIEW is what the "Preview with sample patient" shows in its place.
export const BOOKING_LINK_SAMPLE_URL = 'https://prod.teamio.app/b/xxxxxxx';
export const BOOKING_LINK_PREVIEW_URL = 'https://prod.teamio.app/b/•••••••';
